/*
 *Filename: /home/codestax/MyMedicine/MyMed_Frontend/src/store/OPDConfigCommonState.js *
 *Path: /home/codestax/MyMedicine/MyMed_Frontend                               *
 *Created Date: Tuesday, March 19th 2024, 11:05:49 am                          *
 *Author: Prakersharya                                                         *
 *                                                                             *
 *Copyright (c) 2024 Trinom Digital Pvt Ltd                                    *
 */


 import Fuse from 'fuse.js';
 import { axios_auth_instance_hba_customer, base_axios_instance_hospital_customer } from '../utils/axios_utils';
 const initialState = {
     opdSpec: [],
     packageSpec: [],
     academics: {},
 };
 
 const OPDConfigCommonState = {
    namespaced: true,
     state() {
         return initialState;
     },
     getters: {
        //  getFilteredDoctorInHospitalList(state) {
        //      return state.filteredDoctorsInHospitalList;
        //  },
        //  getNonFilteredDoctorInHospitalList(state) {
        //      return state.doctorList;
        //  },
     },
     mutations: {
        uploadOPDSpecialtyInfo(state, data) {
            state.opdSpec = data;
        },
        uploadPackageSpecialtyInfo(state, data) {
            state.packageSpec = data;
        },
        uploadAcademicsInfo(state, data) {
            state.academics = data;
        },    
    },
     actions: {
        async loadOPDSpecialty(context, payload) {
            try {
                let apiResponse = await axios_auth_instance_hba_customer.get(`/master/OPD_SPEC`);
                let masterInfo = apiResponse.data.itemList;
                context.commit('uploadOPDSpecialtyInfo', masterInfo);
                context.commit('makeFetchingHospitalDataFalse');
            } catch (error) {
                console.log('Error While fetching opd specialty info', error);
            }
        },
        async loadPackageCategory(context, payload) {
            try {
                let apiResponse = await axios_auth_instance_hba_customer.get(`/master/PACKAGE_CAT`);
                let masterInfo = apiResponse.data.itemList;
                context.commit('uploadPackageSpecialtyInfo', masterInfo);
            } catch (error) {
                console.log('Error While fetching package specialty info', error);
            }
        },
        async loadAcademicsTitle(context, payload) {
            try {
                let apiResponse = await axios_auth_instance_hba_customer.get(`/master/ACADEMIC_TITLE`);
                let masterInfo = apiResponse.data.itemList;
                let academicObj = {};
                masterInfo.forEach((item) => {
                    academicObj[item.id] = item;
                });
                context.commit('uploadAcademicsInfo', academicObj);
            } catch (error) {
                console.log('Error While fetching package specialty info', error);
            }
        },
     },
 };
 export default OPDConfigCommonState;